import { TitrateConstants } from '../store/titrate.constants'

export const titrateSchemas = [
  {
    inputKey: TitrateConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TitrateConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TitrateConstants.SET_COMMENTS,
    isNumber: false,
    type: 'object',
    properties: {
      SET_COMMENTS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,999}$',
      },
    },
    additionalProperties: false,
    required: ['SET_COMMENTS'],
    errorMessage: {
      properties: {
        SET_COMMENTS: 'Must be alphanumeric with max length of 1000',
      },
    },
  },
]

export const titrateSecondsSchemas = [
  {
    inputKey: TitrateConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
